import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setRegion,
  setTritiumHtoInventory,
  setTritiumDustInventoryPerMonth,
  setTritiumStackHeight,
} from "../../../store/reducers/configurationSlice";
import {
  BackButton,
  Button,
  ButtonsWrapper,
  Container,
  ContentCard,
  Form,
  Title,
  Label,
} from "../SharedStyles";
import SliderInput from "../../Shared/SliderInput";

const SafetyConfiguration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const region = useSelector(
    (state) => state.configuration.input.basic.region
  );
  const initHtoInventory = useSelector(
    (state) => state.configuration.input.safety.tritiumRelease.htoInventory_g
  );
  const initDustInventoryPerMonth = useSelector(
    (state) =>
      state.configuration.input.safety.tritiumRelease.dustInventory_g_perMonth
  );
  const initStackHeight = useSelector(
    (state) => state.configuration.input.safety.tritiumRelease.stackHeight_m
  );

  const handleBack = () => {
    navigate("/configurations/basic");
  };

  const handleNext = () => {
    navigate("/configurations/power");
  };

  const handleRegionChange = (event) => {
    dispatch(setRegion(event.target.value));
  };

  return (
    <Container>
      <ContentCard>
        <Title>Safety &amp; Hazards Configuration</Title>
        <Form>
          <p>
            Configure high-level safety and hazard assumptions used for
            licensing, insurance, and safety-driven land and mitigation
            costs in the costing model.
          </p>

          <Label htmlFor="region">Regulatory region</Label>
          <select
            id="region"
            value={region || "UNSPECIFIED"}
            onChange={handleRegionChange}
            style={{ marginBottom: "16px", padding: "8px" }}
          >
            <option value="UNSPECIFIED">Unspecified</option>
            <option value="US">United States</option>
            <option value="UK">United Kingdom</option>
          </select>

          <SliderInput
            label="Tritium inventory (HTO)"
            description="Mobilisable tritiated-water (HTO) inventory used to estimate site boundary and land cost for tritium release scenarios."
            unit="g"
            defaultValue={4700}
            min={0}
            max={10000}
            step={10}
            setValue={(value) => dispatch(setTritiumHtoInventory(value))}
            initValue={initHtoInventory}
          />

          <SliderInput
            label="Dust tritium inventory"
            description="Mobilisable tritium in dust per month, used alongside HTO inventory in the site boundary model."
            unit="g/month"
            defaultValue={58000}
            min={0}
            max={120000}
            step={1000}
            setValue={(value) =>
              dispatch(setTritiumDustInventoryPerMonth(value))
            }
            initValue={initDustInventoryPerMonth}
          />

          <SliderInput
            label="Stack height"
            description="Effective release height for stack-driven tritium and dust emissions."
            unit="m"
            defaultValue={20}
            min={0}
            max={60}
            step={1}
            setValue={(value) => dispatch(setTritiumStackHeight(value))}
            initValue={initStackHeight}
          />

          <ButtonsWrapper>
            <BackButton type="button" onClick={handleBack}>
              Back
            </BackButton>
            <Button type="button" onClick={handleNext}>
              Next
            </Button>
          </ButtonsWrapper>
        </Form>
      </ContentCard>
    </Container>
  );
};

export default SafetyConfiguration;

